import {
  type UseInfiniteQueryOptions,
  useInfiniteQuery,
} from '@tanstack/react-query';
import { concat } from 'lodash';
import { PaginationResponse } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetLocationSubZones = (
  filters: string[] = [],
  overrideQuerySetting?: UseInfiniteQueryOptions<PaginationResponse<string[]>>,
) => {
  return useInfiniteQuery({
    queryKey: queryKeys.getLocationSubzones.pagination(filters),
    queryFn: ({ pageParam = 1 }) =>
      fetchLocationSubZones(concat(filters, [`page=${pageParam}`])),
    staleTime: Infinity,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = lastPage ? allPages.length : 1;
      const totalPages = lastPage ? lastPage.totalPages : 1;

      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    ...overrideQuerySetting,
  });
};

const fetchLocationSubZones = async (
  filters: string[] = [],
): Promise<PaginationResponse<string[]>> => {
  const url = `/getLocationSubzones${generateQuery([], filters)}`;
  const response = await requestCCApi({ url });

  return {
    data: response.data,
    totalPages: response.totalPages ?? 0,
    totalCount: response.totalCount ?? 0,
  } as PaginationResponse<string[]>;
};
